import React from 'react';
import { usePermissions } from '@pankod/refine-core';
import {
  IResourceComponentsProps,
  HttpError,
  CrudFilters,
} from '@pankod/refine-core';
import {
  List,
  TagField,
  DateField,
  Table,
  useTable,
  EditButton,
  ShowButton,
  DeleteButton,
  Space,
  Row,
  Col,
} from '@pankod/refine-antd';
import { USER_ROLES, FORM_STATUS } from 'constant';
import { SubmissionTypes } from 'interfaces';

import { Filter } from 'components';

const SubmissionList: React.FC<IResourceComponentsProps> = () => {
  const { data: permissionsData } = usePermissions();
  const { tableProps, searchFormProps } = useTable<
    SubmissionTypes,
    HttpError,
    SubmissionTypes
  >({
    initialSorter: [
      {
        field: 'name',
        order: 'desc',
      },
    ],
    initialFilter: [
      {
        field: 'status',
        operator: 'eq',
        value: 'QUERY',
      },
    ],
    metaData: {
      fields: [
        'id',
        'name',
        'email',
        'phone',
        'country',
        'company',
        'message',
        'status',
        'createdAt',
        'updatedAt',
      ],
    },

    onSearch: (params) => {
      const filters: CrudFilters = [];
      const { status } = params;

      filters.push({
        field: 'status',
        operator: 'eq',
        value: status,
      });

      return filters;
    },
  });

  return (
    <Row gutter={[30, 30]}>
      <Col xs={24}>
        <List headerButtons={<Filter formProps={searchFormProps} />}>
          <Table {...tableProps} rowKey='id'>
            <Table.Column
              key='name'
              dataIndex='name'
              title='Name'
              sorter={{ multiple: 1 }}
            />
            <Table.Column key='email' dataIndex='email' title='Email' />
            <Table.Column key='phone' dataIndex='phone' title='Phone' />
            <Table.Column key='country' dataIndex='country' title='Country' />
            <Table.Column
              dataIndex='company'
              title='Company'
              render={(company) => <TagField value={company ?? '----'} />}
            />
            <Table.Column
              dataIndex='createdAt'
              title='CreatedAt'
              render={(createdAt) => (
                <DateField format='LLL' value={createdAt} />
              )}
              sorter={{ multiple: 2 }}
            />
            <Table.Column
              dataIndex='status'
              title='Status'
              render={(status) => (
                <TagField
                  color={
                    status === FORM_STATUS.LEAD
                      ? 'green'
                      : status === FORM_STATUS.QUERY
                      ? 'orange'
                      : 'red'
                  }
                  value={status ?? '----'}
                />
              )}
            />

            <Table.Column<SubmissionTypes>
              title='Actions'
              dataIndex='actions'
              render={(_, record) => (
                <Space>
                  <EditButton hideText size='small' recordItemId={record.id} />

                  <ShowButton hideText size='small' recordItemId={record.id} />

                  {permissionsData?.role === USER_ROLES.SUPER_ADMIN && (
                    <DeleteButton
                      hideText
                      size='small'
                      recordItemId={record.id}
                    />
                  )}
                </Space>
              )}
            />
          </Table>
        </List>
      </Col>
    </Row>
  );
};

export default SubmissionList;
